import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { StyledSpinner } from './FullSpinner.styled';

export const FullSpinner = () => (
  <StyledSpinner>
    <CircularProgress color="inherit" />
  </StyledSpinner>
);
